import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import {
  useGetAllModelQuery,
  useRemoveModelMutation,
} from "../../../features/api/modelApi";
import AddSubItem from "../SubItem/AddSubItem";
import AddSubItemList from "./AddSubItemList";
import UpdateSubItemList from "./UpdateSubItemList";

const SubItemList = () => {
  const { data, isLoading } = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const productModels = data?.data?.filter((d) => d?.subcategory_id === 10);

  const [removeModel] = useRemoveModelMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const response = await removeModel(id);
        if (!response?.error) {
          toast.success("Delete Success..!!!");
        } else {
          toast.error(response?.error?.data?.error);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = productModels?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Expenses Sub Items List</h1>
        <div className="flex items-center gap-4">
          <AddSubItem />
          <AddSubItemList />
        </div>
      </div>
      <input
        type="text"
        placeholder="Search..."
        className="border focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="py-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : productModels?.length === 0 ? (
          <p className=" text-xl text-red-500">Product Model not found</p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Main Item</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sub Item</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sub Item List</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{row?.subCategory}</TableCell>
                      <TableCell>{row?.product}</TableCell>
                      <TableCell>{row?.model_name}</TableCell>
                      <TableCell className="">
                        <div className="flex items-center gap-x-4">
                          <UpdateSubItemList productModel={row} />
                          {/* <span onClick={() => handleDelete(row?.model_id)}>
                            <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                          </span> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[100, 200, 300]}
              component="div"
              count={productModels?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SubItemList;
